export interface CustomerTelephoneDetails {
  Home?: string | null;
  other?: string | null;
  work?: string | null;
}
